import { CmykColor, ColorGroup, Colors, PredefinedTexts, RgbColor, ColorTag } from './../../models/color.model';

const primary: ColorGroup = {
  name: 'Primary Colors',
  text: {
    predefinedText: PredefinedTexts.Primary
  },
  colors: [
    {
      name: 'S1 Green Speed',
      color: {
        hex: '#4CD981',
        rgb: new RgbColor(76, 217, 129),
        cmyk: new CmykColor(61, 0, 70, 0)
      },
      variants: [
        { hex: '#205734', rgb: new RgbColor(32, 87, 52) },
        { hex: '#2F834D', rgb: new RgbColor(47, 131, 77) },
        { hex: '#3CAE67', rgb: new RgbColor(60, 174, 103) },
        { hex: '#77E19B', rgb: new RgbColor(119, 225, 155) },
        { hex: '#9CE9B4', rgb: new RgbColor(156, 233, 180) },
        { hex: '#BEF0CD', rgb: new RgbColor(190, 240, 205), invertedText: true },
      ],
      tags: [
        ColorTag.Cta, ColorTag.Icon, ColorTag.Link, ColorTag.Illustration
      ]
    }
  ]
};

const secondary: ColorGroup = {
  name: 'Secondary Colors',
  text: {
  },
  colors: [
  ]
};

const gradients: ColorGroup = {
  name: 'Gradients',
  colors: [
    
  ]
};

const bw: ColorGroup = {
  name: 'Greyscale',
  text: {
    predefinedText: PredefinedTexts.BlackAndWhite
  },
  colors: [
    {
      name: 'S6 Jet Black',
      color: {
        hex: '#000000',
        rgb: new RgbColor(0, 0, 0)
      },
      tags: [
        ColorTag.Heading, ColorTag.Background, ColorTag.Paragraph, ColorTag.Logo
      ]
    },
    {
      name: 'S7 Dark Stone',
      color: {
        hex: '#484848',
        rgb: new RgbColor(72, 72, 72),
        cmyk: new CmykColor(0, 0, 0, 89)
      },
      tags: [
        ColorTag.Background, ColorTag.Illustration
      ]
    },
    {
      name: 'S8 Steel Grey',
      color: {
        hex: '#868683',
        rgb: new RgbColor(134, 134, 131),
        cmyk: new CmykColor(51, 43, 43, 7)
      },
      tags: [
        ColorTag.Icon, ColorTag.Paragraph, ColorTag.Illustration
      ]
    },
    {
      name: 'S9 Cloudy Light',
      color: {
        hex: '#F2F2F2',
        rgb: new RgbColor(242, 242, 242),
        cmyk: new CmykColor(0, 0, 0, 5),
        invertedText: true
      },
      tags: [
        ColorTag.Heading, ColorTag.Background, ColorTag.Paragraph
      ]
    }
  ]
};

export const ScannetColors: Colors = {
  updated: new Date(2020, 3, 22),
  package: {
    content: [
    ],
  },
  groups: [primary, secondary, gradients, bw],
  cmykExample: { hex: '#4CD981', cmykAsHex: '#6eba70' }
};
